"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatRelativeTime = exports.formatAbsoluteTime = void 0;
var _distance_in_words = _interopRequireDefault(require("date-fns/distance_in_words"));
var _relativeTimeBuildLocale = _interopRequireDefault(require("./relativeTime.buildLocale.helper"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var formatAbsoluteTime = function formatAbsoluteTime(time) {
  return new Date(time).toLocaleString('en-US', {
    hour12: false
  });
};
exports.formatAbsoluteTime = formatAbsoluteTime;
var formatRelativeTimeOptions = function formatRelativeTimeOptions(_ref) {
  var locale = _ref.locale;
  return {
    locale: locale && (0, _relativeTimeBuildLocale.default)({
      locale: locale
    }),
    includeSeconds: true,
    addSuffix: true
  };
};
var formatRelativeTime = function formatRelativeTime(_ref2) {
  var then = _ref2.then,
    now = _ref2.now,
    locale = _ref2.locale;
  return (0, _distance_in_words.default)(now, then, formatRelativeTimeOptions({
    locale: locale
  }));
};
exports.formatRelativeTime = formatRelativeTime;